import {UyapRequest} from "./UyapRequest";
import {ResponseType} from "axios";
import JSZip from "jszip";


export interface IIcraTalepEvrakHazirlaParamsData {
    dosyaId: string | number,
    filename: string,
    dosyaEsasNo: string,
    kisiKurumId: number,
    talepBilgileri: string
}

export default class IcraTalepEvrakHazirla extends UyapRequest<IIcraTalepEvrakHazirlaParamsData, Blob> {

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "İcra talep evrakı hazırlanıyor...";
    }


    getResponseType(): ResponseType {
        return 'blob'
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return {}
    }

    getUrl(): string {
        return this.ImzaClientAddr + "getIcraTalepEvrakHazirla.uyap";
    }

    /** Icerigin basi; trim() BOM (U+FEFF) dahil bosluklari kirpar. */
    private static bas(icerik: string): string {
        return icerik.slice(0, 1000).trim();
    }

    private static zipMi(icerik: string): boolean {
        return IcraTalepEvrakHazirla.bas(icerik).indexOf("PK") === 0;
    }

    /**
     * Cevap gercekten UDF mi?
     * Bu istek responseType:'blob' ile atildigi icin UyapRequest'teki tryForXml/tryForJson
     * kontrolleri calismaz (Blob uzerinde .error alani yok, xml2js Blob'u parse edemez).
     * Kontrol edilmezse UYAP'in hata cevabi ({"error":...} / login HTML'i) sessizce
     * "content.xml" olarak zip'lenip sahte bir UDF gibi imzaciya gonderiliyordu; imzaci
     * bozuk evraki isleyemedigi icin kullaniciya "Evrak boş olamaz" gibi alakasiz hatalar
     * donuyor ve UYAP'in asil hata mesaji hicbir yere yazilmiyordu. (DEV-1131)
     *
     * Kabul tarafi bilerek genis: gecerli bir UDF'i yanlislikla reddetmek, hatali cevabi
     * kacirmaktan daha kotu. Sadece iki imza araniyor - zip basligi ya da UDF sablonunun
     * <template> koku. XML bildirimi sart kosulmuyor; UYAP bugun "<?xml ...?><template ...>"
     * donuyor ama basligi degistirirse evrak hazirlama komple durmasin.
     */
    private static udfMi(icerik: string): boolean {
        if (IcraTalepEvrakHazirla.zipMi(icerik))
            return true;                                            // zip formatinda UDF
        // UYAP 08/04/2019'dan beri duz xml donuyor
        return IcraTalepEvrakHazirla.bas(icerik).indexOf("<template") >= 0;
    }

    /** UDF olmayan cevaptan kullaniciya gosterilebilecek bir mesaj cikarir. */
    private static hataMesajiCikar(icerik: string): string {
        let kirpilmis = icerik.trim();
        try {
            let json = JSON.parse(kirpilmis);
            let mesaj = json.error || json.message || json.hataMesaji;
            if (mesaj)
                return String(mesaj) + (json.errorCode ? " (" + json.errorCode + ")" : "");
        } catch (_) {
            // json degil, asagida devam
        }
        // Ayni metin UyapRequest'ten de gelebiliyor; tazeleme mantigi bu ifadeyi tanidigi icin
        // tek kaynaktan veriliyor (bkz. TAZELENMEYECEK_HATALAR).
        if (/<html/i.test(kirpilmis))
            return UyapRequest.UYAP_SERVIS_ULASILAMIYOR;
        return kirpilmis.slice(0, 500);
    }

    async parse(data: Blob): Promise<Blob> {
        if (!data || data.size === 0)
            throw new Error("Boş veya geçersiz UDF dosyası alındı");

        let icerik = await data.text();
        if (!icerik)
            throw new Error("UDF içeriği okunamadı");

        if (!IcraTalepEvrakHazirla.udfMi(icerik))
            throw new Error("Talep evrakı hazırlanamadı. UYAP cevabı: " +
                IcraTalepEvrakHazirla.hataMesajiCikar(icerik));

        if (IcraTalepEvrakHazirla.zipMi(icerik)) {
            console.log("UDF zaten ZIP formatında");
            return data;
        }

        /**
         * 08/04/2019
         * uyap güncellemesi ile
         * GELEN UDF zip olarak gelmiyor artık gelen xml datası mı diye text e çevirilip kontrol ediliyor.
         * eğer zip olarak gelirse X tarihte ona göre de kontrol koyuldu.
         * PK gelen data zip mi değilmi kontrolüdür.
         * Emre
         * @return zip blob data;
         */
        let zip = new JSZip();
        zip.file("content.xml", data);
        let content = await zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: {
                level: 6
            }
        });
        if (!content || content.size === 0)
            throw new Error("ZIP dönüşümü başarısız oldu");

        let blob = new Blob([content], {type: "application/octet-stream"}); // udf type ına çeviriliyor.
        (blob as any).name = ((data as any).name || '').replace(/\//g, '_');
        console.log("UDF CONVERTING BLOB", blob);
        return blob;
    }
}